import { Link } from 'react-router-dom';
import achc from '@/assets/images/dashboard/footer/achc.svg';
import legit from '@/assets/images/dashboard/footer/legit.svg';
import nabp from '@/assets/images/dashboard/footer/nabp.svg';
import urac from '@/assets/images/dashboard/footer/urac.svg';

const logos = [
    {
        src: legit,
        link: 'https://www.legitscript.com/websites/?checker_keywords=medbox.com',
        alt: 'LegitScript'
    },
    {
        src: achc,
        link: 'https://www.achc.org/',
        alt: 'ACHC'
    },
    {
        src: nabp,
        link: 'https://app.us.openbadges.me/view/#!/badge?badgeid=18c10173-c11c-4ee9-8b56-fee4dbf5c1af',
        alt: 'NABP'
    },
    {
        src: urac,
        link: 'https://www.urac.org/',
        alt: 'URAC'
    }
];

interface IProps {
    showText?: boolean;
    customClasses?: string;
}

export const AccreditedLogos: React.FC<IProps> = ({ showText = true, customClasses = '' }) => {
    return (
        <div className="flex flex-col justify-center items-center gap-[.75rem] font-atkinsonBold font-bold text-16 leading-[133%] text-center text-white">
            {showText && (
                <span className="block text-center">
                    Accredited by the Industry's <br />
                    Leading Organizations
                </span>
            )}

            <div className={`flex items-center gap-[8px] sm:gap-[12px] rounded-full bg-primary-1600 px-[16px] py-[12px] ${customClasses}`}>
                {logos.map((item, i) => (
                    <Link to={item.link} target="_blank" key={`link-${i}`}>
                        <img src={item.src} className="h-[60px] sm:h-[68px]" alt={item.alt} />
                    </Link>
                ))}
            </div>
        </div>
    );
};

export default AccreditedLogos;
